import { ICommand, IDatasource, IDefineCommand, IQuery, IQueryMediator, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APCourseGroup } from '../../global/builders/ap_course_group_builder';
import { APGenericSlotBuilder, CourseSlot } from '../../global/builders/ap_generic_slot_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../../global/builders/ap_planned_course_builder';
import {
  APProgramSlot,
  IAPProgramSlotMeta,
  SingleCourseProgramSlot,
  SingleCourseProgramSlotMeta
} from '../../global/builders/ap_program_slot_builder';
import { APTerm } from '../../global/builders/ap_term_builder';
import { PlannedCourse } from '../../global/builders/planned_course_builder';
import { IAPCoursesDatasource } from '../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';
import { APCourseServant } from '../../global/servants/ap_course_servant';
import { APTermServant } from '../../global/servants/ap_term_servant';
import { IAPCoursesTermsRelationship } from '../../plan/relationship/ap_courses_terms_relationship';
import { APTermCourseDataQueryhelper } from './ap_term_course_data_query_helper';

export interface IAPPastTermsQueryResult {
  hasPastTerms: boolean;
  pastTermCount: number;
  terms: APTerm[];
}

export class APPastTermsQuery implements IQuery {
  private __result: IAPPastTermsQueryResult;

  constructor(
    QueryMediator: IQueryMediator,
    private ngAPCoursesTermsRelationship: IAPCoursesTermsRelationship,
    private ngAPTermsDatasource: IAPTermsDatasource,
    private ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private ngAPTermCourseDataQueryhelper: APTermCourseDataQueryhelper,
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource
  ) {
    QueryMediator.registerQuery(this, ngAPTermsDatasource, ngAPCoursesDatasource, ngAPPlannedCourseGroupDatasource);
  }

  run(): this {
    const terms = this.ngAPTermsDatasource.read();
    const pastTerms = _4
      .chain(terms)
      .filter((term: APTerm) => term.is_past_term)
      .sortBy(`rank`)
      .value();

    const pastTermCoursesWithMeta = this.ngAPTermCourseDataQueryhelper.getPastTermCoursesWithMetaInfo();

    _4.each(pastTerms, (term) => {
      term._genericSlots = [];

      const coursesInTerm = _4.filter(pastTermCoursesWithMeta, { term: term.id });
      term._plannedCourses = coursesInTerm;
      term._genericSlots = _4.map(coursesInTerm, (pastTermCourse) => {
        // For past term course, we mark all the requirement met
        const plannedCourse = {
          ...pastTermCourse,
          coreq_miss: [],
          coreq_outoforder: [],
          is_coreq_satisfied: true,
          is_prereq_course_satisfied: true,
          is_prereq_grade_satisfied: true,
          is_prereq_satisfied: true,
          prereq_miss: [],
          prereq_outoforder: [],
          _hasRequisiteProblem: false,
          _hasPreReq: false,
          _coreq_miss: [],
          _coreq_outoforder: [],
          _prereq_miss: [],
          _prereq_outoforder: [],
          _coreq: []
        };
        return APGenericSlotBuilder.build({
          title: `${plannedCourse._course.cd} ${plannedCourse._course.title}`,
          type: 'COURSE',
          termId: term.id,
          course: plannedCourse._course,
          plannedCourse,
          isLockedByAdvisor: plannedCourse.is_locked,
          programSlot: {} as SingleCourseProgramSlot & IAPProgramSlotMeta,
          status: plannedCourse.status,
          isDragEnabled: false,
          credits: plannedCourse._course.credits,
          isPlanned: true,
          isPlannedSomewhere: true,
          isLockedByStatus: APCourseServant.isLockedByStatus(plannedCourse.status),
          hoverTemplate: APCourseServant.buildHoverTemplate(plannedCourse._course)
        });
      });
      term._statusGroups = APTermServant.sortCourseBucketCategories(term._genericSlots, term);
      term._creditsRange = _4.sumBy(term._plannedCourses, '_course.credits').toString();
    });

    this.__result = {
      hasPastTerms: !_4.isEmpty(this.ngAPCoursesTermsRelationship.model.mapTermToCourse),
      pastTermCount: _4.size(pastTerms),
      terms: pastTerms
    };

    return this;
  }

  get result(): IAPPastTermsQueryResult {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPPastTermsQuery', APPastTermsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_past_terms_query.ts